<template>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-card-text-outline</v-icon>
      Connections
    </div>
    <v-spacer />
    <HelpButton mdxName="ConnectionsConfig" />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Omni Connection</v-card-subtitle>
      <v-divider />
    </div>
    <v-text-field
      v-on:keyup.enter="update_config_details()"
      filled
      background-color="textBoxBackground"
      label="Omni IP Address"
      hint="The public IP address of CanvasPro Omni that this player will connect to"
      persistent-hint
      v-model="omniIpAddress"
      class="my-3"
      @input="edited = true"></v-text-field>
    <v-text-field
      v-on:keyup.enter="update_config_details()"
      filled
      background-color="textBoxBackground"
      label="Username"
      hint="Any additional infomation one might want to know about this machine"
      persistent-hint
      class="my-3"
      @input="edited = true"
      v-model="omniUsername"></v-text-field>
    <v-text-field
      v-on:keyup.enter="update_config_details()"
      filled
      background-color="textBoxBackground"
      label="Password"
      hint="Any additional infomation one might want to know about this machine"
      persistent-hint
      class="my-3"
      @input="edited = true"
      v-model="omniPassword"></v-text-field>

    <div style="margin-top: 40px; margin-bottom: 20px">
      <v-card-subtitle>Cloud State Stream</v-card-subtitle>
      <v-divider />
    </div>
    <v-text-field
      v-on:keyup.enter="update_state_stream_url()"
      filled
      background-color="textBoxBackground"
      label="Cloud Edge URL (state-stream)"
      hint="WebSocket URL of the CanvasPro cloud Worker this player streams its state to (e.g. wss://canvaspro-state-stream.canvaspro.workers.dev/state_ingest). Leave blank to disable cloud streaming."
      persistent-hint
      class="my-3"
      @input="cloudEdited = true"
      v-model="cloudStateStreamUrl"></v-text-field>
    <div style="display: flex">
      <v-spacer />
      <v-btn
        :disabled="!cloudEdited"
        color="primary"
        @click="update_state_stream_url()"
        variant="flat">
        <v-icon class="ml-1 mr-2">mdi-cloud-upload-outline</v-icon>
        Save Cloud URL
      </v-btn>
    </div>

    <v-divider
      class="mt-3"
      style="margin-bottom: 12px" />
    <div style="display: flex">
      <v-spacer />
      <v-btn
        :disabled="!edited"
        color="primary"
        @click="update_config_details()"
        variant="flat">
        <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
    </div>
    <OmniButtons />
  </div>
</template>
<script setup>
import { onMounted, ref, watch, onBeforeUnmount, computed } from 'vue';
import { state } from '../../stores/deluge.js';
import { $http } from '../../stores/http.js';
import HelpButton from '../Help-Hints/HelpButton.vue';
import OmniButtons from './Connections/OmniButtons.vue';
import { deluge } from '@/stores/deluge.js';

const omniUsername = ref('');
const omniIpAddress = ref('');
const omniPassword = ref('');
const edited = ref(false);
const cloudStateStreamUrl = ref('');
const cloudEdited = ref(false);

function initializeData() {
  omniUsername.value = deluge.config?.extra_info?.omni?.username || '';
  omniIpAddress.value = deluge.config?.extra_info?.omni?.ip_address || '';
  cloudStateStreamUrl.value =
    deluge.config?.extra_info?.state_stream_url || '';
  console.log(deluge.config);
}

onMounted(() => {
  initializeData();
});
function is_omni() {
  return deluge['canvaspro_core_info']['product_name'].toLowerCase() === 'omni';
}
async function update_config_details() {
  await $http(
    'PUT',
    '/update_omni_details',
    JSON.stringify({
      username: omniUsername.value,
      ip_address: omniIpAddress.value,
      password: omniPassword.value,
    })
  );
  edited.value = false;
}

async function update_state_stream_url() {
  await $http(
    'PUT',
    '/update_state_stream_url',
    JSON.stringify({ url: cloudStateStreamUrl.value.trim() })
  );
  cloudEdited.value = false;
}
</script>
<style scoped>
@import './config.css';

.resizable-content {
  border-width: 2px;
  border-style: solid;
  height: 100%;
  width: 100%;
  cursor: grab;
  border-radius: 3px;
  box-sizing: border-box;
}
.resizable-content:active {
  cursor: grabbing;
}
.frameitem-tl {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute !important;
  cursor: nw-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}
.frameitem-tr {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute;
  right: 0 !important;
  cursor: ne-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}
.frameitem-br {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute;
  bottom: 0 !important;
  right: 0 !important;
  cursor: se-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}
.frameitem-bl {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute !important;
  bottom: 0 !important;
  cursor: sw-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.frame-button {
  flex-grow: 1 !important;
  margin-right: 5px !important;
  margin: 5px;
}
</style>
